module.exports = __webpack_public_path__ + "img/hsetup.831e7be1.gif";